import axios from "axios";
import { AppConfig } from "../../shared/utilities/AppConfig";
import { SearchPoliceProfilesResponse } from "../../shared/definitions/internationalTypes";

export type SearchPoliceProfilesParams = {
  search: string;
  page?: number;
};

export default async function searchPoliceProfiles(
  params: SearchPoliceProfilesParams,
) {
  const { search, ...restParams } = params;
  const { data } = await axios.get<SearchPoliceProfilesResponse>(
    `${AppConfig.API_URL}/search_kepolisian_internasional/${encodeURIComponent(search)}`,
    { params: restParams },
  );

  return data;
}
